/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef ,useEffect} from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millBracket.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation4.play();
    actions.Animation4.repetitions = 1;
    actions.Animation4.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="bracket" geometry={nodes.bracket.geometry} material={materials.霧面黑} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millBracket.glb')
